import { chain } from "lodash";
import { singular } from "pluralize";

export const classifyResource = (resource) =>
  chain(singular(resource)).camelCase().upperFirst().value();
